export default __webpack_public_path__ + "static/media/stat-39-papers.bec15bd6.svg";